<template >
    <div class="product-list-element" :class="{ updating }" >
      <img class="cdn-image" :src="cdnImage" />
        <div class="details-box" >
            <div class="display-series">{{seriesIdentifier}}</div>
            <div class="sales-name">{{product.salesName}}</div>
            <div class="sku">{{$t('common.sku')}} {{product.SKU}}</div>
        </div>
        <div class="pricing-box" v-if="mode == 'list'" >
            <div class="flags">
                &nbsp;
            </div>
            <div class="availaibilty-message" v-if="availabilityObject" :key="availabilityObject.sku">
                <img v-if="getAmountClass(product) === 'availability-low'" class="availability-noticer" src="@/assets/GreenInfoSmall.svg"/>
                <div :class="getAmountClass(product)">{{availabilityObject.state.message}}
                    <span v-if="getAmountClass(product) === 'availability-available'">( {{ getAvailable(product) }} )</span>
                    <span v-else> {{ getAvailable(product) }} </span>
                </div>
            </div>

            <div v-if="isHistoric === true" >
                Looks historic
            </div>

            <div v-if="hasOfferPrice" class="price">
                <span class="oldPrice">
                    <span v-if="dealerLocale() == 'fi'"> {{parseFloat((product.defaultPrice)).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€</span>
                    <span v-else> {{parseFloat((product.defaultPrice)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-</span>
                </span>
                <span v-if="dealerLocale() == 'fi'"> {{parseFloat((product.offerPrice)).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€</span>
                <span v-else> {{parseFloat((product.offerPrice)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-</span>
            </div>
            <div v-else class="price">
                <div class="price" v-if="dealerLocale() == 'fi'"> {{parseFloat((product.defaultPrice)).toLocaleString('fi-FI',{maximumFractionDigits:2, minimumFractionDigits:2})}}€</div>
                <div v-else class="price"> {{parseFloat((product.defaultPrice)).toLocaleString('nb-NB',{maximumFractionDigits:0})}}.-</div>
            </div>
        </div>
        <router-link  v-if="mode == 'list'"   v-on:keydown.enter="scrollToTop" class="product-link" :to="{name: 'ProductView', params: {sku: product.SKU}}">
            <img style="width: 60px;height: 60px;margin-right: -10px;cursor: pointer;" src="@/assets/ItemMenu.svg"/>
        </router-link>

        <div class="pricing-box" v-if="mode == 'quick' && custlist?.lines.length > 0" >
            <div class="price" :key="custlist?.id">
                {{$t('common.amount', [orderListAmount(product.SKU)])}}
            </div>
        </div>
      <div class="pricing-box" v-if="mode == 'quick' && qty > 0" >
        <div class="price" :key="custlist?.id">
          {{$t('common.amount', [qty])}}
        </div>
      </div>

    </div>

</template>

<script>
 import {mapGetters} from "vuex";

 export default {
     name: "ProductListElement",
     props: {
         updating: { type: Boolean, default: false },
         line_type: {type: Number, default:1},
         custlist: null,
         mode: { type: String, default: 'list' },
         product: {
             avatar: '',
             salesName:'',
             defaultPrice: 0,
             displaySeries:'',
             SKU:'',
             availability: {
                 state: {
                     state: "active",
                     message: "Tilgjengelig",
                     buyable: true
                 },
                 roof: 250,
                 qty: 0
             }
         },
         qty: {type: Number, default:0},
         historic: { type: Boolean, default: false },

     },
     computed:{
         ...mapGetters(['dealerLocale']),
         cdnImage(){
             let avatarFile = ''
             if(this.product.images.productMain != null){
                 if(this.product.images.productMain.length > 0){
                     if(this.product.images.productMain[0].image){
                         avatarFile = this.product.images.productMain[0].image.name
                     }
                 }
             }
             if (!avatarFile){
                 return 'https://perfecthome.com/images/logo.svg'
             } else {
                 if (avatarFile.length > 0){
                     return `${process.env.VUE_APP_CDN_URL}images/pim/202/${avatarFile}`
                 } else {
                     return 'https://perfecthome.com/images/logo.svg'
                 }
             }
         },
         isHistoric(){
             if (this.historic == true){
                 console.log("is historic: " . this.product.SKU);
                 return true;
             }
             //console.log("is NOT historic");
             return false;
         },
         seriesIdentifier(){
             return this.product.displaySeries.toUpperCase()
             // return this.product.salesName.substr(0, this.product.salesName.indexOf(' ')).toUpperCase()
         },
         hasOfferPrice(){
             if (this.product.offerPrice < this.product.defaultPrice){
                 return true
             }
             return false
         },
         availabilityObject(){
             return this.$store.getters.getStockItem(this.product.SKU)
         }
     },
     methods: {
         scrollToTop() {
             window.scrollTo(0,0);
         },
         getAmountClass(product){
             let stockObj = this.$store.getters.getStockItem(product.SKU)
             if(!stockObj){
                 return 'availability-unbuyable'
             }
             if(stockObj.state.buyable){
                 if(stockObj.qty <= 0){
                     return 'availability-unavailable'
                 }else if(stockObj.qty < 15){
                     return 'availability-low'
                 }else {
                     return 'availability-available'
                 }
             }else{
                 return 'availability-unbuyable'
             }
         },
         orderListAmount (sku) {
             let arr = this.custlist.lines.filter(item => {
                 return parseInt(item.productId) === parseInt(sku) && item.productTypeId === this.line_type
             })

             if (arr.length) {

                 return arr[0].quantity
             }
             return 0
         },
         getAvailable(product){
             //console.log("ProductListElement:getAvailable");
             let stockObj = this.$store.getters.getStockItem(product.SKU)
             if(!stockObj){

                 return '0'
             }
             if (!stockObj.state.buyable) {
                 return '0'
             } else {
                 if (stockObj.qty <= 0){
                     return '0'
                 } else {
                     if (stockObj.qty > stockObj.roof){
                         return '> ' + stockObj.displayQty
                     } else {
                         return stockObj.qty
                     }
                 }
             }
         }

     }

 }
</script>

<style scoped>

</style>
